export default "__VITE_ASSET__4c433531__"